import React, { Component, Fragment } from 'react';
import { BreadCrumb } from '../../components/BreadCrumb';
import { LanguageConsumer, Translate } from '../../contexts/LanguageContext';
import { Card, TransferOption, Loading, HistoryPeriod } from '../../components';
import DataTable from 'react-data-table-component';
import { DataTableColumns } from '../../helpers/DataTableColumns';
import { TransferOptionService } from '../../services/TransferOptionService';
import { PaymentService } from '../../services/PaymentService';

const unipayment = {
    "title": "uniPAYMENT",
    "description": null,
    "logo": "",
    "url": "unipayment",
    "processingTime": "Instant",
    "fee": "Free",
    "acceptedCurrencies": [
        "USD"
    ],
    "outside": false,
    "rules": null
}

export class Deposit extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            DepositHistory: [],
            DepositOptions: []
        }
    }
    componentWillMount() {

        TransferOptionService.Deposit.Page().then(response => {

            if (response) {
                this.setState({
                    DepositOptions: response.depositOptions,
                    DepositHistory: response.depositHistory,
                    loading: false
                });
            } else {
                this.setState({
                    loading: false
                });
            }


            let period = localStorage.getItem("period");

            if (period)
                this.onPeriodChange(period);
                
        });
    }
    componentDidMount(){
        PaymentService.Deposit.Unipayment.getInvoices({});
    }
    onPeriodChange(key) {

        this.setState({ loading: true }, () => {

            TransferOptionService.Deposit.History(key).then(response => {

                if (response) {
                    this.setState({
                        loading: false,
                        DepositHistory: response
                    });
                }
                else {
                    this.setState({
                        loading: false
                    })
                }

            });

        });
    }
    render() {

        const depositOptionList = this.state.DepositOptions.map((item, index) => (
            <TransferOption key={index} Item={item} ButtonTitle="Deposit Now" />
        ));

        return (
            <LanguageConsumer>
                {() => (
                    <Fragment>
                        <Loading Show={this.state.loading} Title={Translate("Loading Content")} />
                        <BreadCrumb Title={Translate("Deposit")} Name={Translate("Deposit")} />
                        <div className="row tra-dw__page">
                            {depositOptionList}
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <Card Title={Translate("Deposit History")} Description={Translate("Recent successful deposits")} Tools={<HistoryPeriod onChange={(key) => this.onPeriodChange(key)} />}>
                                    {this.state.DepositHistory.length === 0 ? (
                                        <div className="alert alert-light" role="alert">
                                            <em><strong>{Translate('No record!')}</strong> {Translate('You have no successful deposit transactions.')} </em>
                                        </div>) : (
                                            <DataTable
                                                noHeader={true}
                                                columns={DataTableColumns.deposit}
                                                data={this.state.DepositHistory}
                                                defaultSortField="id"
                                                defaultSortAsc={false}
                                                pagination
                                                highlightOnHover />
                                        )}
                                </Card>
                            </div>
                        </div>
                    </Fragment>

                )}
            </LanguageConsumer>
        )
    }
}